import {Injectable} from '@angular/core';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtCommandService} from '@app/services/gt-command.service';
import {PushEventsMock} from '@testhelper/mocks/push-events.mock';
import {PushEventService} from './push-event/push-event.service';

@Injectable({
  providedIn: 'root'
})
export class DemoService {
  queuedSessionIds = [];

  constructor(
    private pushEventService: PushEventService,
    private commandService: GtCommandService,
    private authenticationService: GtAuthenticationService
  ) {}

  setupDemoPush() {
    this.commandService.commands.subscribe(c => {
      switch (c.name) {
        // case 'demo absent':  setTimeout(() => {
        //   this.pushEventService.pushSubjects.DoNotDisturbEvent.next({
        //     doNotDisturbOn: true,
        //     deviceIdentifier: '+4790847731',
        //     companyId: this.authenticationService.oname,
        //     key: 'key',
        //   });
        // }, 1000); break;

        // case 'demo established':
        //   this.startEUStates();
        //   break;

        case 'demo incoming':
          const createCallMock = PushEventsMock.getCreateCallPush(this.authenticationService.login, this.authenticationService.oname);

          setTimeout(() => {
            this.pushEventService.pushSubjects.CreateCall.next(createCallMock);
          }, 1000);
          break;

        case 'demo queued':
          const createQueueMock = PushEventsMock.getEnqueuePush(this.authenticationService.login, this.authenticationService.oname);
          this.pushEventService.pushSubjects.Enqueue.next(createQueueMock);
          this.queuedSessionIds.push(createQueueMock.session_id);
          break;

        case 'demo dequeued':
          const sessionId = this.queuedSessionIds.shift();
          const createDequeueMock = PushEventsMock.getDequeuePush(
            this.authenticationService.login,
            this.authenticationService.oname,
            sessionId
          );
          this.pushEventService.pushSubjects.Dequeue.next(createDequeueMock);
          break;

        case 'demo answered':
          const createAnswerMock = PushEventsMock.getAnsweredCallPush(this.authenticationService.login, this.authenticationService.oname);
          this.pushEventService.pushSubjects.AnsweredCall.next(createAnswerMock);
          break;

        case 'demo hangup':
          const disconnectCall = PushEventsMock.getDisconnectedCallPush(this.authenticationService.login, this.authenticationService.oname);
          this.pushEventService.pushSubjects.DisconnectedCall.next(disconnectCall);
          break;

        // case 'demo consult': this.pushEventService.pushSubjects.TransferCall.next({
        //   login: this.authenticationService.login,
        //   transfer_type: 3,
        //   transferToNumber: '+4791808621',
        //   groupId: this.authenticationService.groupId,
        //   session_id: 22,
        //   type: 'TransferCall',
        //   timestamp: new Date().getTime(),
        //   cid: 0,
        //   sno: '+4799426875',
        //   agent_number: this.authenticationService.login,
        //   agent_index: 0,
        //   agent_dep_id: 0,
        //   a_number: '+4799223344',
        //   agent_login: this.authenticationService.login,
        //   redir_number: '+4778974010:101,4791908920:11,4773503618:101',
        //   g_number: '+4799223344'
        // });
        //
        // setTimeout(() => {
        //   this.pushEventService.pushSubjects.TransferCallAnswered.next({
        //     login: this.authenticationService.login,
        //     transfer_type: 3,
        //     transferToNumber: '+4791808621',
        //     groupId: this.authenticationService.groupId,
        //     session_id: 22,
        //     type: 'TransferCallAnswered',
        //     timestamp: new Date().getTime(),
        //     cid: 0,
        //     sno: '+4799426875',
        //     agent_number: this.authenticationService.login,
        //     agent_index: 0,
        //     agent_dep_id: 0,
        //     a_number: '+4799223344',
        //     agent_login: this.authenticationService.login,
        //     redir_number: '+4778974010:101,4791908920:11,4773503618:101',
        //     g_number: '+4799223344'
        //   });
        // }, 4000);
        //
        // break;
      }
    });
  }

  // private startEUStates() {
  //   this.directoryService.getContacts(this.authenticationService.oname, false).subscribe(contacts => {
  //     contacts = contacts.filter(contact => contact.isEndUser());
  //     const count = contacts.length;
  //     setInterval(() => {
  //       const index = Math.floor(Math.random() * count);
  //       const contact = contacts[index];
  //       if (contact) {
  //         this.toggleEuState(contact);
  //       }
  //     }, 2000);
  //   });
  // }

  // toggleEuState(contact: ContactModel) {
  //   if (contact.memberState === 0) {
  //     const createCallMock = PushEventsMock.getEUCreateCallPush(this.authenticationService.login, this.authenticationService.oname);
  //     this.pushEventService.pushSubjects.EUCreateCall.next(createCallMock);
  //   } else {
  //     console.log("toogkle EU STATE")
  //     const dcCallMock = PushEventsMock.getEUDisconnectedCallPush(this.authenticationService.login, this.authenticationService.oname);
  //     this.pushEventService.pushSubjects.EUDisconnectedCall.next(dcCallMock);
  //   }
  // }
}
